var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"selectUser",attrs:{"value":_vm.selectedUserIds,"label":_vm.label ??
		(_vm.multiple
			? _vm.$localize('SelectUser.field.users')
			: _vm.$localize('SelectUser.field.user')),"items":_vm.users,"item-text":"name","item-value":"userId","clearable":true,"rules":_vm.rules(),"multiple":_vm.multiple,"outlined":!_vm.form,"flat":!_vm.form,"solo":!_vm.form,"prepend-icon":"mdi-account-tie","autofocus":_vm.autofocus,"loading":_vm.loading,"hide-details":_vm.hideDetails},on:{"input":function($event){return _vm.onUserSelected($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }